import {
  fetchReservationData,
  updateBrandCode,
  updatePrearrivalSession,
  type PrearrivalSessionData,
} from '../api/reservationService';

export const fetchReservationSpecificData = async (marshaCode: string, confirmationNumber: string) => {
  const offersResponse = await fetchReservationData(marshaCode, confirmationNumber);
  return offersResponse;
};

export const updateBrandCodeSessionData = async (brandCode: string, sessionId: string) => {
  const sessionUpdateResponse = await updateBrandCode(brandCode, sessionId);
  return sessionUpdateResponse;
};

export const updatePrearrivalSessionData = async (prearrivalSessionData: PrearrivalSessionData, sessionId: string) => {
  const sessionUpdateResponse = await updatePrearrivalSession(prearrivalSessionData, sessionId);
  return sessionUpdateResponse;
};
